var initiatedAnimations = false;

document.addEventListener("readystatechange", function(e) {
    switch (this.readyState) {
        case "interactive":
        case "complete":
            if (!initiatedAnimations) {
                initiatedAnimations = true;
                initAnimations();
            }
    }
});

function initAnimations() {
    var scroller = 0,
        scrollX = window.scrollX,
        scrollY = window.scrollY;
    
    var menu = document.getElementById("main_menu"),
        menuSClass = menu.getAttribute("data-sclass");
    
    function checkMenu() {
        try {
            if (menuSClass && menuSClass !== "") {
                if (scrollY > 30) {
                    removeClass(menu, menuSClass);
                } else {
                    addClass(menu, menuSClass);
                }
            }
        } catch (err) {}
    }
    
    function updateScroller() {
        scroller = 60;
        scrollY = window.scrollY;
    }
    
    function actions() {
        if (scroller > 0) {
            scroller--;
            // Include all per frame actions below;
            checkMenu();
        }
        rAF(actions);
    }
    
    rAF(actions);
    
    window.addEventListener("scroll", updateScroller);
}